module.exports = __webpack_public_path__ + "static/media/CalendarEvent2.a5cb7351.jpg";